export default __webpack_public_path__ + "static/media/5-SkeletonPage.1900686a.jpeg";